// extracted by mini-css-extract-plugin
export default {"root":"YYp68tMfqodWh6VCHZyw","label":"l9xXzzpz7C957zefnlwD","closed":"bNqrbBjvuOcidZ1MC9vI"};